export default __webpack_public_path__ + "static/media/challenge-sample.5cd2c1b2.png";